import React, { useState, useEffect } from 'react';

function Clock() {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const timeString = time.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzShort = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
        .formatToParts(time)
        .find(p => p.type === 'timeZoneName')?.value || '';

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontFamily: 'var(--font-mono)',
        }}>
            <span style={{
                fontSize: '0.85rem',
                fontWeight: 600,
                color: 'var(--text-primary)',
                letterSpacing: '0.02em',
            }}>{timeString}</span>
            {tzShort && (
                <span style={{
                    fontSize: '0.75rem',
                    color: 'var(--text-muted)',
                    fontWeight: 500,
                    padding: '2px 6px',
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid var(--glass-border)',
                }}>{tzShort}</span>
            )}
        </div>
    );
}

export default Clock;
